import styled from '@emotion/styled';
import React from 'react';

import useIsPermitted from 'App/utils/hooks/useIsPermitted';
import { PERMISSION_TYPES } from 'App/utils/isPermitted/isPermitted';
import { TextField } from 'Shared/form/TextField';
import { WysiwygField } from 'Shared/form/WysiwygField';
import questionPropType from '../types/questionPropType';
import QuestionAccordionWrapper from './QuestionAccordionWrapper';

const TextSectionStyle = styled.div`
    .markdown-contents {
        min-height: 8em;
    }
`;

const QuestionTextSection = ({ question }) => {
    const isClinicalAdmin = useIsPermitted(PERMISSION_TYPES.CLINICAL_ADMIN);
    const isQuestionTextLocked = question.attributes.locked && !isClinicalAdmin;

    return (
        <QuestionAccordionWrapper
            questionId={question.question_id}
            statePath="sections.text"
            title="Question Text"
            headerClassName="assessment-manager-question-section-header"
        >
            <TextSectionStyle>
                <WysiwygField
                    fieldName={`questions.${question.question_id}.question`}
                    label="Question - Fully Scripted"
                    disabled={isQuestionTextLocked}
                    debounce
                    required
                />

                <WysiwygField
                    fieldName={`questions.${question.question_id}.compact_question`}
                    label="Question - Compact"
                    disabled={isQuestionTextLocked}
                    debounce
                />

                {(isClinicalAdmin || question.attributes.is_mobile) && (
                    <WysiwygField
                        fieldName={`questions.${question.question_id}.mobile_question`}
                        label="Question - Mobile"
                        disabled={isQuestionTextLocked}
                        debounce
                        required={question.attributes.is_mobile}
                    />
                )}

                <TextField
                    fieldName={`questions.${question.question_id}.description`}
                    label="Question - Description"
                    placeholder="Description"
                    disabled={isQuestionTextLocked}
                    debounce
                />

                <TextField
                    fieldName={`questions.${question.question_id}.attributes.extra_info`}
                    label="Question - Extra Information"
                    placeholder="Extra Information"
                    debounce
                />
            </TextSectionStyle>
        </QuestionAccordionWrapper>
    );
};

QuestionTextSection.propTypes = {
    question: questionPropType.isRequired,
};

export default React.memo(QuestionTextSection);
